import { Injectable } from '@angular/core';

/** Service que valida os acessos e execuções de funcionalidades dos pacotes de campanhas */
@Injectable({
    providedIn: 'root'
})
export class PacoteCampanhaAuthGuardService {

    /** Verifica se pode editar um pacote de campanha */
    canEdit(): boolean {
        return true;
    }

    /** Verifica se pode excluir um pacote de campanha */
    canDelete(): boolean {
        return true;
    }
}
